import React from "react";
import { Link } from "react-router-dom";
import { Home, LayoutGrid } from "lucide-react";
import { LogoWordmark } from "@/components/Logo";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-background" data-testid="not-found-page">
      <header className="border-b border-border px-6 py-4">
        <Link to="/">
          <LogoWordmark size={32} />
        </Link>
      </header>
      <main className="mx-auto flex w-full max-w-lg flex-1 flex-col items-center justify-center px-6 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">404</p>
        <h1 className="mt-3 font-display text-3xl font-bold tracking-tight">This page isn’t here</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          The link may be outdated, or that screen moved. Head back to the home page or your workspace.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button asChild className="gap-2 font-semibold">
            <Link to="/">
              <Home className="h-4 w-4" /> Home
            </Link>
          </Button>
          <Button asChild variant="outline" className="gap-2">
            <Link to="/dashboard">
              <LayoutGrid className="h-4 w-4" /> Workspace
            </Link>
          </Button>
        </div>
      </main>
    </div>
  );
}
